import { HEADER_BLOCK } from "./../ricos-content/index.js";
const DOC_STYLE_TYPES = {
  P: "paragraph",
  H1: "headerOne",
  H2: "headerTwo",
  H3: "headerThree",
  H4: "headerFour",
  H5: "headerFive",
  H6: "headerSix"
};
const DRAFT_TO_DOC_TYPE = {
  [HEADER_BLOCK.ONE]: "headerOne",
  [HEADER_BLOCK.TWO]: "headerTwo",
  [HEADER_BLOCK.THREE]: "headerThree",
  [HEADER_BLOCK.FOUR]: "headerFour",
  [HEADER_BLOCK.FIVE]: "headerFive",
  [HEADER_BLOCK.SIX]: "headerSix",
  [HEADER_BLOCK.PARAGRAPH]: "paragraph"
};
const DRAFT_TO_DOC_TYPE_WITH_LISTS = {
  ...DRAFT_TO_DOC_TYPE,
  "ordered-list-item": "paragraph",
  "unordered-list-item": "paragraph"
};
export {
  DOC_STYLE_TYPES,
  DRAFT_TO_DOC_TYPE_WITH_LISTS
};
//# sourceMappingURL=editorTypes.js.map
